import script from "./editDocumentFieldPreference.vue?vue&type=script&setup=true&lang=ts"
export * from "./editDocumentFieldPreference.vue?vue&type=script&setup=true&lang=ts"

import "./editDocumentFieldPreference.vue?vue&type=style&index=0&id=62440f0f&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62440f0f"]])

export default __exports__